import { Component, Inject, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import DirectusService from '@/core/directus/directus.service';
import CustomPageCMSModel from '@/visa-application/models/CustomPageCMSModel';
import LanguageCode from '@/locale/language-code';
import { ALL_COUNTRY_CODE } from '@/constants';
import { getCmsDataByCountryAndDefault, defineCanonicalTag } from '@/shared/utils/utils';

@Component
export default class CustomizedCountry extends Vue {
  public cmsData: CustomPageCMSModel = new CustomPageCMSModel();
  public pageName = '';

  @Inject('directusService')
  private directusService: () => DirectusService;
  public residenceCountryCode: string;

  public beforeRouteEnter(to, from, next) {
    defineCanonicalTag(to.params.residenceCountryCode, to.params.issuer, to.params.formGroupId, to.fullPath);

    next(vm => {
      vm.residenceCountryCode = to.params.residenceCountryCode;
      vm.pageName = to.params.page;
      vm.unwatchCurrentLanguage = vm.$store.watch(
        () => vm.$store.getters.currentLanguage,
        currentLanguage => {
          vm.getContent(currentLanguage);
        },
        { immediate: true }
      );
    });
  }

  public getContent(currentLanguage: LanguageCode) {
    const filter = {
      'country.code': {
        in: [this.residenceCountryCode, ALL_COUNTRY_CODE]
      }
    };
    this.directusService()
      .getCollection<CustomPageCMSModel>(CustomPageCMSModel, this.pageName, ['*.*.*'], filter, currentLanguage)
      .then(response => {
        this.cmsData = getCmsDataByCountryAndDefault(response, this.residenceCountryCode);
        this.$store.commit('metaInfo', this.cmsData);
      })
      .catch(() => this.$router.push({ name: 'NotFound' }));
  }
}
